// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"966faf3b","496":"de76d2fe","782":"02210275"}[chunkId] + ".chunk.js";
};